import React, { FC } from 'react';
import { Check } from './styles';

const CheckIcon: FC = ({ ...rest }) => {
	return <Check {...rest} />;
};

export default CheckIcon;
